import React from 'react';
import Stack from 'react-bootstrap/Stack';

import CreateTokenForm from './Components/CreateTokenForm';
import IssueTokenForm from './Components/IssueTokenForm';
import TokensList from './Components/TokensList';
import AntelopeTokenAPI from './Helpers/AntelopeTokenAPI';
import ToastMessage from './Widgets/ToastMessage';
import { SharedStateContext } from './Helpers/SharedState';
import './App.css';

function App() {
    const [state, setState] = React.useState({});
    const [sharedState, {updateState, isLoggedIn}] = React.useContext(SharedStateContext);
    const isTokenCreated = !!sharedState.token;

    /* eslint-disable react-hooks/exhaustive-deps */
    React.useEffect(() => {
        if (isLoggedIn && sharedState.antelopeSession) {
            const tokenAPI = new AntelopeTokenAPI(sharedState.antelopeSession);
            tokenAPI.fetchTokenDetails().then(token => updateState({token}));
        }
    }, [isLoggedIn]);

    // Transaction Successful (Antelope)
    function showTrxSuccessMessage(trxHash) {
        setState({trxHash});
    };

    function hideTrxSuccessMessage() {
        setState({trxHash: undefined});
    };

    // EVM Token Deployed (EVM)
    function showEVMTokenDeployedMessage(trxHash, contractAddress) {
        setState({evmTokenDeployed: {trxHash, contractAddress}});
    };

    function hideEVMTokenDeployedMessage() {
        setState({evmTokenDeployed: undefined});
    };

    return (
        <>
            {/* ToastMessage */}
            <ToastMessage.TransactionSigned
                isShown={!!state.trxHash}
                trxHash={state.trxHash}
                onAutoClosed={hideTrxSuccessMessage}
            />

            {/* Check if logged in otherwise we might be passing in an unsupported chainID */}
            { (isLoggedIn && !!sharedState?.evmSession) &&
                <ToastMessage.EVMTokenDeployed
                    isShown={!!state.evmTokenDeployed}
                    chainID={sharedState?.evmSession?.chainID}
                    trxHash={state.evmTokenDeployed?.trxHash}
                    contractAddress={state.evmTokenDeployed?.contractAddress}
                    onCloseClicked={hideEVMTokenDeployedMessage}
                />
            }

            {/* App */}
            <Stack className="App">
                <Stack className="App-content col-12 col-sm-10 col-md-8 col-xl-6 col-xxl-5 mx-auto">
                    { isTokenCreated && <IssueTokenForm/> }
                    { !isTokenCreated &&  <CreateTokenForm onAntelopeTokenCreated={showTrxSuccessMessage} onEVMTokenCreated={showEVMTokenDeployedMessage}/> }

                    { !isLoggedIn &&
                        <div>
                            <h6 style={{marginBottom: '1rem'}}>Telos Zero Tokens:</h6>
                            <TokensList/>
                        </div>
                    }
                </Stack>

                <footer className="App-Footer">
                    Copyright © {new Date().getFullYear()} Baboon. All rights reserved
                </footer>
            </Stack>
        </>
    );
}

export default App;
